import moment from 'moment';
import React from 'react';

import { calcShortcutInterval, granularity } from '@utils';
import { DATE_SHORTCUTS } from '@utils/constants';

const getDateShortcuts = () => [
  [DATE_SHORTCUTS.past24Hours, calcShortcutInterval(DATE_SHORTCUTS.past24Hours)],
  [DATE_SHORTCUTS.today, calcShortcutInterval(DATE_SHORTCUTS.today)],
  [DATE_SHORTCUTS.yesterday, calcShortcutInterval(DATE_SHORTCUTS.yesterday)],
  [DATE_SHORTCUTS.lastWeek, calcShortcutInterval(DATE_SHORTCUTS.lastWeek)],
  [DATE_SHORTCUTS.past7Days, calcShortcutInterval(DATE_SHORTCUTS.past7Days)],
];

/**
 * withDefaultOptions
 * This provides default options -> DisabledDate and shortcut dates
 */
const withDefaultOptions = (Wrapper) => {
  class WithDefaultOptionsHOC extends React.PureComponent {
    getDisabledDate = () => (current) => {
      const { durationAllowed, calenderBoundry } = this.props;
      // If calenderBoundry is provided, prioritise it to set the disabled dates
      if (calenderBoundry?.start_time && calenderBoundry?.end_time) {
        const startDate = moment(calenderBoundry.start_time).startOf('day');
        const endDate = moment(calenderBoundry.end_time).endOf('day');
        return current.isBefore(startDate, 'day') || current.isAfter(endDate, 'day');
      }
      return (
        current.isAfter(moment(), 'day') ||
        current.isBefore(moment().subtract(durationAllowed, 'month'), 'day')
      );
    };

    getTimeGranularity = (from, to) => {
      const g = granularity(from, to, true);
      switch (g) {
        case 'PT1M':
          return 5;
        case 'PT1H':
          return 60;
        default:
          return null;
      }
    };

    render() {
      const { innerRef, shortcuts, ...rest } = this.props;
      return (
        <Wrapper
          disabledDate={this.getDisabledDate()}
          shortcuts={shortcuts || getDateShortcuts()}
          granularity={this.getTimeGranularity}
          ref={innerRef}
          {...rest}
        />
      );
    }
  }

  WithDefaultOptionsHOC.defaultProps = {
    innerRef: React.createRef(),
    durationAllowed: 13, // months
  };
  return WithDefaultOptionsHOC;
};

export default withDefaultOptions;
